import { render } from "./TheMyCollectionCollectionDropdown.vue?vue&type=template&id=98aed948&scoped=true&ts=true"
import script from "./TheMyCollectionCollectionDropdown.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionCollectionDropdown.vue?vue&type=script&lang=ts"

import "./TheMyCollectionCollectionDropdown.vue?vue&type=style&index=0&id=98aed948&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98aed948"]])

export default __exports__